export default __webpack_public_path__ + "static/media/rpo-1.b81bfdc2.jpg";